/**
Project: Voice Panel (c)
Title: Blank Layout  
Description: Component for hadling the routes of non logged-in pages
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Signin from "../../core/components/signin";
import SigninSilentStart from "../../core/components/signin-silent-start";
import SigninSilentEnd from "../../core/components/signin-silent-end";
import SigninInteractiveEnd from "../../core/components/signin-interactive-end";
import SignoutInteractive from "../../core/components/signout-interactive";
import SignOut from "../../core/components/sighout";
import ErrorPage from "../../core/views/error-page";
import Error404 from "../../core/views/error-404";
import ErrorFrame from "../../core/views/error-frame";


class BlankLayout extends Component {
  render() {
    return (
      <Switch>
        <Route path="/signin" exact component={Signin} />
        <Route
          path="/signin-silent-start"
          exact
          component={SigninSilentStart}
        />
        <Route path="/signin-silent-end" exact component={SigninSilentEnd} />
        <Route
          path="/signin-interactive-end"
          exact
          component={SigninInteractiveEnd}
        />
        <Route
          path="/signout-interactive"
          exact
          component={SignoutInteractive}
        />
        <Route path="/error-frame" exact component={ErrorFrame} />
        <Route path="/signout" exact component={SignOut} />
        <Route path="/error" exact component={ErrorPage} />
        <Route path="/404" exact component={Error404} />
      </Switch>
    );
  }
}

export default BlankLayout;
